import { MessageBox } from 'element-ui'
import store from '@/store'
import router from '@/router'
import { parseApiError, resolveErrorTitle } from './apiError'

let alerting = false

/**
 * 后台管理：错误弹框（MessageBox）
 */
export function showAdminErrorAlert(error, options = {}) {
  const err = parseApiError(error)
  const title = options.title || resolveErrorTitle(err.code, err.httpStatus, err.message)

  if (err.code === 401 || err.httpStatus === 401) {
    handleAdminUnauthorized()
  }

  if (options.silent || alerting) {
    return Promise.reject(err)
  }

  alerting = true
  return MessageBox.alert(err.message, title, {
    type: 'error',
    confirmButtonText: '知道了',
    closeOnClickModal: false,
    closeOnPressEscape: true,
    callback: () => {
      alerting = false
    }
  }).catch(() => {
    alerting = false
  }).then(() => Promise.reject(err))
}

export function handleAdminUnauthorized() {
  store.dispatch('adminLogout')
  const current = router.currentRoute
  if (current && current.path !== '/admin/login') {
    router.replace({
      path: '/admin/login',
      query: { redirect: current.fullPath }
    })
  }
}
